import "./App.css";
import Footer from "./Presentation/Util/Footer/Footer";
import NavBar from "./Presentation/Util/NavBar/NavBar";
import ReportDumping from "./Presentation/Screen/ReportDumping/ReportDumping";

function App() {
  return (
    <>
      <NavBar />
      <ReportDumping />
      <Footer />
    </>
  );
}

export default App;
